import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CONTRACT_RENT_CONTENT_TEMPLATE_ITEM_EDIT_FORM_SCHEMA = yup.object().shape({
  content: yup.string().required('Molimo Vas da unesete sadržaj'),

});
